const itinerary = {
    scrollToContinue: 'Scroll to continue',
    expand: 'Expand',
    closeMediaViewer: 'Close media viewer',
    previousMedia: 'Previous media',
    nextMedia: 'Next media',
    pdfDownload: 'Download the PDF version with more details about the trip',
    pdfEnglish: 'in English',
    pdfDutch: 'in Dutch',
    pdfAnd: 'and',
    contactInfo: 'For more information you can contact our staff directly through',
    contactForm: 'contact form',
    contactEmail: 'or by sending an email to',
    contactEmailAddress: 'info@ladolcevitareis.nl'
};

export default itinerary;
